import { Container, ContentContainer, PageTitle } from "@src/core/styles";
import { Wrapper, ImagePageError } from './page-not-found.styled';
import type { FC } from "react";
import { Link } from "react-router-dom";
import { InputGroup } from "../login-page/login-page.styles";
import { Button } from "@src/components";
import PageError from "@src/core/images/404.png";

export const PageNotFound: FC = () => {
    return (
        <Container>
            <ContentContainer>
                <Wrapper>
                    <InputGroup>
                        <PageTitle>Страница не найдена</PageTitle>
                        <div>Перейдите на главную, чтобы продолжить работу</div>
                        <Link to="/">
                            <Button text="На главную" borderradius="XXXL" variant="contained" />
                        </Link>
                    </InputGroup>
                    <div>
                        <ImagePageError src={PageError} />
                    </div>
                </Wrapper>
            </ContentContainer>
        </Container>
    );
};
